import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IGAEADLookupService } from 'app/shared/services/igaead-lookup.service';
import { IGAEADMeetingsService } from 'app/shared/services/igaead-meetings.service';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';
import { BehaviorSubject } from "rxjs";
import { TranslationHelpers } from "../../services/translation-helpers.service";
import { GlobalState } from "../../../layout/common/global.state";

declare const moment: any;

@Component({
    selector: 'app-meeting-details-i18n',
    templateUrl: './meeting-details-i18n.component.html',
    styleUrls: ['./meeting-details-i18n.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MeetingDetailsComponentI18N implements OnInit {

    filterText: string;
    shouldDisplay: boolean = false;
    @Input('filterText')
    set filterTextSet(value: string) {
        this.filterText = value;
        this.shouldShowBasedOnFilter(this.filterText);
    }

    @Input('meeting-data')
    set meetingData(value: string) {
        this.meeting = value;
        if (this.meeting) this.meetingChanged();
    }

    expandAll: boolean;
    @Input('expandAll')
    set expandAllItem(value: any) {
        this.expandAll = value;
        this.setPanelStateBasedOnExpand();
    }

    meeting;
    @Input() lastVisitTime;

    @Output('translationStarted') translationStarted = new EventEmitter();
    @Output('translationCompleted') translationCompleted = new EventEmitter();

    currentSession;
    currentDoc;
    currentBody;
    evotes = [];
    singleEvote;
    selectedVotes = [];
    selectedSponsor = [];
    selectedType = '';
    showVotes = false;
    panelOpenState = false;
    showSponsorship = false;
    mainBody = ''
    processedMeeting: any;
    getTranslationsSub = new BehaviorSubject<any>(null);
    getTranslationsSubSubscription: any;
    isRtl = false;

    constructor(private router: Router,
                private currentRoute: ActivatedRoute,
                public _state: GlobalState,
                private meetingService: IGAEADMeetingsService,
                private translationHelpers: TranslationHelpers,
                public cd: ChangeDetectorRef,
                private lookupService: IGAEADLookupService) {
    }

    ngOnInit(): void {
        this.setPanelStateBasedOnExpand();
        if (this.meeting.isDocExist) this.panelOpenState = true;

        this.getTranslationsSubSubscription = this.getTranslationsSub.subscribe(async (processedMeetingTemp: any)=>{
            let defaultLang = localStorage.getItem('defaultLanguage') || 'en';
            if (defaultLang === 'en') {
                this.shouldShowBasedOnFilter(this.filterText);
                return;
            } else {
                const meetingObjectWithHashValues = JSON.parse(JSON.stringify(processedMeetingTemp));

                let splitText = `<a href="`;
                for (const segment of meetingObjectWithHashValues.segments) {
                    const tempLines = (segment.title || '').split(splitText);
                    for (let i = 0; i < tempLines.length; i++) {
                        if (i === 0) continue;
                        const line = tempLines[i];
                        tempLines[i] = `${splitText}${line}`;
                    }
                    segment.titleLines = tempLines;
                }

                const fields = {
                    dayName: 1,
                    dateText: 1,
                    timeText: 1,
                    MT_name: 1,        // used by shouldShowBasedOnFilter()
                    MT_commentary: 1,  // rendered via [innerHTML]
                    MTS_segmentInfo: 1,
                    titleLines: 1,
                    title: 1,
                    meetingTitle: 1,
                    meetingVenue: 1,
                    documentTitle: 1,
                    documents_arr: 1,
                    paragraph: 1,
                    stepText: 1,
                    addoption: 1,
                    wasAdoptedWithOral: 1,
                    wasAdopted: 1,
                    oral: 1,
                    voteTextBy: 1,
                    voteTextVotesTo: 1,
                    voteTextWith: 1,
                    voteTextAbstentions: 1,
                    label: 1,
                    name: 1
                };
                const allValuesOfMeeting: { hash: string, value: string }[] = this.translationHelpers.collectUniqueStrings(meetingObjectWithHashValues, fields);
                this.translationStarted.emit();
                try {
                    const translationOutput: any = await this.meetingService.getTranslations(allValuesOfMeeting);
                    this.processedMeeting = this.translationHelpers.restoreOriginalStrings(meetingObjectWithHashValues, translationOutput.lines);
                    for (const segment of this.processedMeeting.segments) {
                        segment.title = segment.titleLines.join('');
                        segment.titleLines = undefined;
                    }
                    this.shouldShowBasedOnFilter(this.filterText);
                } catch (e) {
                    console.log(e);
                }
                this.translationCompleted.emit();
                if (defaultLang === 'ar') this.isRtl = true;
            }
        });
    }

    setPanelStateBasedOnExpand() {
        if (this.expandAll) this.panelOpenState = true;
        else this.panelOpenState = false;
    }

    meetingChanged(): void {
        this.currentSession = this.currentRoute.snapshot.paramMap.get('sessionID');
        this.currentDoc = this.currentRoute.snapshot.queryParamMap.get('document');
        this.currentBody = (this.currentRoute.snapshot.paramMap.get('body') || "plenary").replace('.', '').toLowerCase();
        this.mainBody = this.router.url.split('/')[1];

        if (this.expandAll) {
            this.panelOpenState = true;
        } else {
            this.panelOpenState = false;
        }

        if (this.meeting) {
            let segments = [];
            for (let segment of this.meeting.MT_segment) {
                if (segment.MTS_Public === 'Yes') {
                    let title = this.getTitle(segment);
                    let steps = [];
                    for (let step of this.meeting.procedureStep) {
                        if (step.PS_Public === 'Yes' && step.seqNo >= segment.seqNo && step.seqNo < (segment.seqNo + 1)) {
                            let computedStep = {
                                ...step,
                                documentTitle: this.getDocumentTitle(segment.MTS_selectDocumentFromWorkPackage, step, segment.seqNo),
                                documents_arr: this.getDocument(step.PS_selectDocumentFromWorkPackage, step.PS_outcome),
                                paragraph: this.getPatargraph(step, segment),
                                wasAdopted: this.wasAdoptedText(step, false, this.getWasPrefix(step)),
                                oral: this.getOral(step),
                                addoption: this.getAddoption(step),
                                stepText: this.getStepText(step, segment),
                                voteInFavor: step.PS_InFavor,
                                voteTextBy: 'by',
                                voteTextVotesTo: 'votes to',
                                voteAgainst: step.PS_against,
                                voteTextWith: 'with',
                                voteAbstention: step.PS_abstention,
                                voteTextAbstentions: 'abstentions',
                                wasAdoptedWithOral: `${this.wasAdoptedText(step, false, this.getWasPrefix(step))} ${this.getOral(step)}`.trim(),
                                meetingReference: step.PS_linkListOfSpeakers && step.PS_linkListOfSpeakers.RF_id ? this.getMeetingReference(step.PS_linkListOfSpeakers.RF_id) : '',
                                isDiscussion: step.PS_linkListOfSpeakers ? this.checkIsDiscussion(step) : false
                            };
                            steps.push(computedStep);
                        }
                    }
                    segments.push({
                        ...segment,
                        title: title,
                        steps: steps
                    });
                }
            }
            const dateParts = this.getDateParts(this.meeting);
            this.processedMeeting = {
                ...this.meeting,
                date: this.getDate(this.meeting),
                dayName: dateParts.dayName,
                dateText: dateParts.dateText,
                timeText: dateParts.timeText,
                meetingTitle: this.getMeetingTitle(this.meeting),
                meetingVenue: this.getMeetingVenue(this.meeting),
                highlight: this.checkMeetingChanges(this.meeting),
                hasReference: this.checkReferenceExist(this.meeting),
                hasJournal: !!(this.meeting.MT_jcmsMeetingId || this.meeting.MT_JCMSMeetingID),
                journalUrl: this.journalUrl(this.meeting.MT_jcmsMeetingId || this.meeting.MT_JCMSMeetingID),
                hasPv: this.meeting.MT_number && this.mainBody == 'ga' && ['plenary', 'c1'].indexOf(this.currentBody) > -1,
                pvUrl: this.pvLink(this.meeting.MT_number),
                hasSvGeneral: this.meeting.MT_number && ['plenary', 'ffd4pc', 'c1'].indexOf(this.currentBody) === -1,
                hasSvEcosocPlenary: this.meeting.MT_number && this.mainBody == 'ecosoc' && this.currentBody == 'plenary',
                svUrl: this.svLink(this.meeting.MT_number),
                segments: segments
            };
        }
        this.getTranslationsSub.next(this.processedMeeting);
    }

    shouldShowBasedOnFilter(text: string) {
        if (!text) return this.shouldDisplay = true;

        let isExactMatch = text[0] == '"' && text[text.length - 1] == '"';
        let regx = null;
        if (isExactMatch) {
            text = text.substring(1, text.length - 1);
            regx = new RegExp(`(?:\\W|^)${this._state.escapeSpecialCharacters(text)}(?:\\W|$)`);
        } else {
            text = text.toLowerCase();
        }

        this.shouldDisplay = false;
        if (isExactMatch && this.processedMeeting.MT_name && this.processedMeeting.MT_name.match(regx)) {
            return this.shouldDisplay = true;
        } else if (!isExactMatch && this.processedMeeting.MT_name && this.processedMeeting.MT_name.toLowerCase().indexOf(text) > -1) {
            return this.shouldDisplay = true;
        }

        // check for date
        if (isExactMatch && this.processedMeeting.date && this.processedMeeting.date.match(regx)) {
            return this.shouldDisplay = true;
        } else if (!isExactMatch && this.processedMeeting.date && this.processedMeeting.date.toLowerCase().indexOf(text) > -1) {
            return this.shouldDisplay = true;
        }


        if (['Informal meeting', 'Informal consultations'].indexOf(this.processedMeeting.MT_type) > -1) {
            if (isExactMatch && this.processedMeeting.MT_commentary && this.processedMeeting.MT_commentary.match(regx)) {
                return this.shouldDisplay = true;
            } else if (!isExactMatch && this.processedMeeting.MT_commentary && this.processedMeeting.MT_commentary.toLowerCase().indexOf(text) > -1) {
                return this.shouldDisplay = true;
            }
        }

        for (let segment of this.processedMeeting.MT_segment) {
            if (isExactMatch && segment.MTS_segmentTitle && segment.MTS_segmentTitle.match(regx)) {
                return this.shouldDisplay = true;
            } else if (!isExactMatch && segment.MTS_segmentTitle && segment.MTS_segmentTitle.toLowerCase().indexOf(text) > -1) {
                return this.shouldDisplay = true;
            }
            for (let procedureStep of this.processedMeeting.procedureStep) {
                if (procedureStep.PS_Public == 'Yes' && procedureStep.seqNo >= segment.seqNo && procedureStep.seqNo < (segment.seqNo + 1)) {
                    let procedureText = this.getPatargraph(procedureStep, segment);
                    if (isExactMatch && procedureText && procedureText.match(regx)) {
                        return this.shouldDisplay = true;
                    } else if (!isExactMatch && procedureText && procedureText.toLowerCase().indexOf(text) > -1) {
                        return this.shouldDisplay = true;
                    }
                }
            }
        }
    }

    checkMeetingChanges(meeting) {
        if (!meeting.MT_UpdatedOn) return false;
        const meetingUpdatedOn = moment(meeting.MT_UpdatedOn);
        const compareTime = moment().subtract(24, 'hours');
        if (!compareTime.isValid()) return false;

        if (meetingUpdatedOn.isAfter(compareTime)) {
            return true;
        }
        return false;

        // let dateValidation = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString();
        // if(meeting.MT_UpdatedOn && meeting.MT_UpdatedOn > this.lastVisitTime && this.lastVisitTime > dateValidation){
        // if (meeting.MT_UpdatedOn && meeting.MT_UpdatedOn > dateValidation) {
        //   return true;
        // }
        // return false;
    }

    public openPage(name: string): void {
        this.router.navigate([name], {});
    }

    symbolOnly(input) {
        if (input != null) return input.replace(/ (DR|DD).*/, '');
    }

    getWasPrefix(step) {
        if (step.PS_type && step.PS_type.label == 'Motion') {
            return true;
        }
        if (step.PS_type && step.PS_type.label == 'Request for separate votes (motion to divide)') {
            return true;
        }
        return false
    }

    wasAdoptedText(step, isNot, withoutWas = true) {
        if (step.PS_type && step.PS_type.label == 'Action (unnumbered decision)' && this.checkTag(step.PS_tags, 'Oral decision')) {
            return '';
        }
        if (step.PS_outcome == 'WITHDRAWN' && withoutWas) {
            return 'withdrawn'
        }
        if (step.PS_outcome == 'WITHDRAWN' && !withoutWas) {
            return 'was withdrawn'
        }
        if (step.PS_outcome == 'ADOPTED' && withoutWas) {
            return 'adopted'
        }
        if (step.PS_outcome == 'ADOPTED' && !withoutWas) {
            return 'was adopted'
        }
        if (step.PS_outcome != 'ADOPTED' && withoutWas) {
            return 'not adopted'
        }
        if (step.PS_outcome !== 'ADOPTED' && !withoutWas) {
            return 'was not adopted'
        }
        return 'was adopted';
    }

    isSummaryEnabled() {
        const enabled = ['c2', 'c3', 'c4', 'c5'].includes(this.currentBody)
        return enabled;
    }

    getPatargraph(step, segment) {
        if (step.PS_type && step.PS_type.label == 'Document taken note of') {
            let docType = [];
            let docSymbol = [];
            for (let doc of step.PS_selectDocumentFromWorkPackage) {
                docType.push(doc.DD_documentType);
                if ((step.PS_outcome == 'ADOPTED' || step.PS_outcome == 'NOT-ADOPTED') && doc.DD_symbol1.indexOf('L.')) {
                    docSymbol.push(`<a style="order: 1;" href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" aria-label="${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a><a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="order: 2; color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link" translate="no"></i></a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="order: 3; color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link" translate="no"></i></a> <button translate="no" style="order: 4;" class="btn btn-outline-secondary sponsor-btn" data-action="sponsorship" data-document="${doc.DD_symbol1}">S</button>`)
                } else {
                    docSymbol.push(`<a style="order: 1;" href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" aria-label="${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a><a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="order: 2; color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link" translate="no"></i></a>`);
                }
                //console.log('calling here2333',`[Document type] ${doc.DD_symbol1} was taken note of (decision ${step.PS_recordDecisionNumber})`);
            }
            //console.log(`${docType.join(', ')} ${docSymbol.join(', ')} was taken note of (decision ${step.PS_recordDecisionNumber})`)
            //return `${docType.join(', ')} ${docSymbol.join(', ')} was taken note of (decision ${step.PS_recordDecisionNumber})`;
            return `${docType.join(', ')} ${docSymbol.join(', ')} was taken note of ${step.PS_recordDecisionNumber ? '(decision ' + step.PS_recordDecisionNumber + ')' : ''}`;
        }
        if (step.PS_type && step.PS_type.label == 'Motion') {
            return `Motion: ${step.PS_text1}`;
        }
        if (step.PS_type && step.PS_type.label == 'Request for separate votes (motion to divide)') {
            return 'Separate votes (motion to divide)';
        }
        if (step.PS_operativeParagraphs && step.PS_operativeParagraphs.length > 0) {
            return `Operative paragraph ${step.PS_operativeParagraphs[0].value} of draft resolution`;
        }
        if (step.PS_type && step.PS_type.label.indexOf('Action') > -1 && step.PS_selectDocumentFromWorkPackage.length == 0 && (segment.MTS_selectDocumentFromWorkPackage && segment.MTS_selectDocumentFromWorkPackage.length == 0 || segment.MTS_selectDocumentFromWorkPackage.length > 1) && step.PS_text1 != "") {
            return step.PS_text1
        }
        if (step.PS_type && step.PS_type.label.indexOf('Action') > -1 && step.PS_selectDocumentFromWorkPackage.length == 0 && (!step.PS_text1 || step.PS_text1 == "")) {
            return '';
        }
        if (step.PS_type && step.PS_type.label.indexOf('Action on amendment') > -1) {
            return 'Amendment';
        }
        if (step.PS_preambularParagraphs && step.PS_preambularParagraphs.length > 0) {
            return `Preambular paragraph ${step.PS_preambularParagraphs[0].value} of draft resolution`;
        }
        if (step.PS_type && step.PS_type.label.indexOf('Statement to orally change') > -1 && step.PS_oralChanges.indexOf('Oral amendment') > -1) {
            let type = "";
            if (this.checkDocument(step.PS_selectDocumentFromWorkPackage)) {
                type = step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
            }
            return `Oral amendment to ${type}`.trim();
        }
        if (step.PS_type && step.PS_type.label.indexOf('Statement to orally change') > -1 && step.PS_oralChanges.indexOf('Oral revision') > -1) {
            let type = "";
            if (this.checkDocument(step.PS_selectDocumentFromWorkPackage)) {
                type = step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
            }
            return `Oral revision to ${type}`.trim();
        }
        if (step.PS_type && step.PS_type.label.indexOf('Statement to orally change') > -1 && step.PS_oralChanges.indexOf('Oral correction') > -1) {
            let type = "";
            if (this.checkDocument(step.PS_selectDocumentFromWorkPackage)) {
                type = step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
            }
            return `Oral correction to ${type}`.trim();
        }
        if (step.PS_type && step.PS_type.label == 'Action (unnumbered decision)' && this.checkTag(step.PS_tags, 'Oral decision')) {
            return step.PS_text1 + ' ' + step.PS_text2 + ' ' + step.PS_text3;
        }
        if (this.checkDocument(step.PS_selectDocumentFromWorkPackage)) {
            return step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
        }
    }

    checkDocument(steps) {

        for (let step of steps) {
            if (step.DD_documentType) {
                return true;
            }
        }
        return false;
    }

    getAddoption(step) {
        if (step.PS_recordResolutionNumber) {
            if (this.mainBody == 'ecosoc') {
                return `(resolution <a href="https://www.undocs.org/E/RES/${step.PS_recordResolutionNumber}" target="_blank" >${step.PS_recordResolutionNumber}</a>)`;
            }
            return `(resolution <a href="https://www.undocs.org/A/RES/${step.PS_recordResolutionNumber}" target="_blank" >${step.PS_recordResolutionNumber}</a>)`;
        } else if (step.PS_recordDecisionNumber) {
            return '(decision' + step.PS_recordDecisionNumber + ')';
        }
        return '';
    }

    getDateParts(params: any): { dayName: string; dateText: string; timeText: string } {
        let dayName = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us', { weekday: "long" });
        let day = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us', { day: "numeric" });
        let month = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us', { month: "long" });
        let year = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us', { year: "numeric" });
        let hour = new Date(params.MT_dateTimeScheduleStart).toLocaleTimeString('en-us', { hour: "2-digit" }).split(' ');

        let minutes = new Date(params.MT_dateTimeScheduleStart).toLocaleTimeString('en-us', { minute: "2-digit" });
        minutes = minutes === '0' ? '00' : minutes;

        let endHour = '';
        if (hour[0] == '10' && params.MT_dateTimeScheduleEnd) {
            let endHourParts = new Date(params.MT_dateTimeScheduleEnd).toLocaleTimeString('en-us', { hour: "2-digit" }).split(' ');
            endHour = endHourParts[0] == '06' ? ' and 3:00 PM ' : '';
        }

        return {
            dayName: dayName,
            dateText: `${day} ${month} ${year}`,
            timeText: `${hour[0]}:${minutes} ${hour[1]}${endHour}`,
        };
    }

    getDate(params: any) {
        const { dayName, dateText, timeText } = this.getDateParts(params);
        return `${dayName}, ${dateText}, ${timeText}`;
    }

    getMeetingTitle(params: any): string {
        if (params.MT_name != "") {
            return params.MT_name;
        }
        return '';
    }

    getMeetingVenue(params: any): string {
        if (params.MT_body == 'GA' && params.MT_type == 'Formal meeting' && params.MT_room == '') {
            return 'General Assembly Hall';
        }
        if (params.MT_room != "") {
            return params.MT_room ? params.MT_room : '';
        }
        return '';
    }

    handleClick(event: Event): void {
        const target = event.target as HTMLElement;

        if (target.tagName === 'BUTTON') {
            const action = target.getAttribute('data-action');
            if (action === 'sponsorship') {
                const document = target.getAttribute('data-document');
                this.getSponsorship(document);
            }
        }
    }

    getTitle(segment) {
        let title = segment.MTS_segmentTitle || '';
        const bracketCheckRegx = /\(/;
        for (let MTS_agenda of segment.MTS_agenda) {
            let code: RegExp, code1: RegExp;
            let onlyItemRegx = new RegExp(`\\b${MTS_agenda.item.toLowerCase()}\\b(?![(])`)
            if (bracketCheckRegx.test(MTS_agenda.item)) {
                code = new RegExp('Item ' + MTS_agenda.item.replace(/([()])/g, "\\$1"));
                code1 = new RegExp('item ' + MTS_agenda.item.replace(/([()])/g, "\\$1"));
                title = title.replace(code, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
                title = title.replace(code1, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
            } else if (onlyItemRegx.test(title.toLowerCase())) {
                code = new RegExp('Item ' + MTS_agenda.item.replace(/([()])/g, "\\$1"));
                code1 = new RegExp('item ' + MTS_agenda.item.replace(/([()])/g, "\\$1"));
                title = title.replace(code, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
                title = title.replace(code1, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
            }

            // //let code = new RegExp(`\\bItem ${MTS_agenda.item}\\b(?![(])`);
            // //let code1 = new RegExp(`\\bitem ${MTS_agenda.item}\\b(?![(])`);

            // if(code.test(MTS_agenda.item)){
            //   code = new RegExp('Item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
            //   code1 = new RegExp('item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
            // }
            // console.log(code,code1);
            // //let code = new RegExp(`\\bItem ` +  MTS_agenda.item.replace(/([()])/g, "\\$1")+"\\b",'g');
            // console.log('code', code);
            // title =  title.replace(code, `<a href="${EnvironmentLoader.environment.localURL}/ga/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
            // //console.log('code 1', code);
            //let code1 = new RegExp(`^item ${MTS_agenda.item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g');
            //let code1 = new RegExp('item ' + MTS_agenda.item.replace(/([()])/g, "\\$1"));

            //title =  title.replace(code1, `<a href="${EnvironmentLoader.environment.localURL}/ga/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
        }
        const seenSymbols = new Set<string>();
        for (let doc of segment.MTS_selectDocumentFromWorkPackage) {
            if (seenSymbols.has(doc.DD_symbol1)) {
                continue;
            }
            seenSymbols.add(doc.DD_symbol1);
            //let code = new RegExp(doc.DD_symbol1)
            let code = new RegExp(`(?:\\W|^)${doc.DD_symbol1}(?:\\W|$)`);
            title = title.replace(code, ` <a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" aria-label="${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" aria-label="${doc.DD_symbol1}" ><i class="fa fa-external-link"></i></a> `)
        }
        //console.log('title', title);
        return title;
    }

    getDocumentTitle(documents, step, seqNo) {

        if (step.PS_type && step.PS_type.label == 'Document before it' && step.PS_Public == 'Yes') {
            let title = [];
            // console.log('step', step.seqNo, step.PS_selectDocumentFromWorkPackage)
            for (let document of step.PS_selectDocumentFromWorkPackage) {
                let docTitle = document.DD_officialTitle;
                if (!docTitle) {
                    docTitle = document.DD_workingTitle;
                }
                title.push(`${docTitle} (<a href="https://undocs.org/${this.symbolOnly(document.DD_symbol1)}" aria-label="${document.DD_symbol1}" target="_blank">${document.DD_symbol1}</a>) <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${document.DD_symbol1}" aria-label="${document.DD_symbol1}" ><i class="fa fa-external-link"></i></a>`);
            }
            return title;
        }
        return []
    }

    getDocument(docs, adopted = ''): { title: string; sponsor: string }[] {
        let titleArr: { title: string; sponsor: string }[] = [];
        if (docs) {
            for (let doc of docs) {
                if ((adopted == 'ADOPTED' || adopted == 'NOT-ADOPTED') && doc.DD_symbol1.indexOf('L.')) {
                    titleArr.push({
                        title: `<a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" target="_blank" style="order:1; color: #151E3D;" aria-label="${doc.DD_symbol1}">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="order: 2; color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link" translate="no"></i></a>`,
                        sponsor: ` <button translate="no" style="order: 3;" class="btn btn-outline-secondary sponsor-btn" data-action="sponsorship" data-document="${doc.DD_symbol1}">S</button>`,
                    })
                } else {
                    titleArr.push({ title: `<a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" target="_blank" style="order:1; color: #151E3D;" aria-label="${doc.DD_symbol1}">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="order: 2; color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link" translate="no"></i></a>`, sponsor: '' })
                }
            }
        }
        return titleArr;
    }

    journalUrl(MT_JCMSMeetingID) {
        return EnvironmentLoader.environment.journalUrl + MT_JCMSMeetingID
    }

    checkIsDiscussion(step) {
        return step.PS_tags.includes(EnvironmentLoader.environment.generalDiscussionTagId);
    }

    pvLink(meetingNo) {
        if (this.currentBody == 'c1') {
            return `https://docs.un.org/A/C.1/${this.currentSession}/PV.${meetingNo}`
        }
        if (this.mainBody.toLowerCase() == 'ecosoc') {
            return `https://undocs.org/E/${this.currentSession}/PV.${meetingNo}`
        }
        return `https://undocs.org/A/${this.currentSession}/PV.${meetingNo}`
    }

    svLink(meetingNo) {
        if (this.mainBody.toLowerCase() == 'ecosoc') {
            return `https://undocs.org/E/${this.currentSession}/SR.${meetingNo}`
        }
        return `https://undocs.org/A/C.${this.currentBody.slice(1)}/${this.currentSession}/SR.${meetingNo}`
    }

    getLisofSpeakers(speakers) {
        let _spekers = [];
        for (let speaker of speakers) {
            _spekers.push(speaker.SP_entity.SP_entity);
        }
        return _spekers.join(',');
    }

    getSymbols(documents) {
        let links = [];
        if (documents) {
            for (let document of documents) {
                links.push(`<a href="https://undocs.org/${this.symbolOnly(document.DD_symbol1)}"  aria-label="${document.DD_symbol1}" target="_blank" >${document.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${document.DD_symbol1}" aria-label="${document.DD_symbol1}" ><i class="fa fa-external-link"></i></a>`)
            }
            return links.join(',');
        }
        return '';
    }

    getMeetingReference(id) {
        return EnvironmentLoader.environment.meetingReference + id;
    }

    changeAccordianState() {
        this.panelOpenState = !this.panelOpenState;
    }

    getSponsorship(doc) {
        const sub = this.meetingService.getSponserData(doc).subscribe((resp: any) => {
            this.showSponsorship = true;
            this.selectedSponsor = resp.result.length > 0 ? resp.result[0].sponsors.sort((a, b) => a - b) : [];

            (async () => {
                const selectedSponsorCloned = JSON.parse(JSON.stringify(this.selectedSponsor));
                const allValuesOfMeeting: { hash: string, value: string }[] = this.translationHelpers.collectUniqueStrings(selectedSponsorCloned, { CO_Mission: 1 });
                this.translationStarted.emit();
                try {
                    const translationOutput: any = await this.meetingService.getTranslations(allValuesOfMeeting);
                    this.selectedSponsor = this.translationHelpers.restoreOriginalStrings(selectedSponsorCloned, translationOutput.lines);
                } catch (e) {
                }
                this.cd.detectChanges();
            })();
        })
    }

    getVotes(id, type) {

        this.selectedType = type;
        if (this.evotes[id]) {
            this.singleEvote = this.evotes[id];
            let votinResult = this.singleEvote?.VT_VoteResults;
            if (votinResult) {
                this.showVotes = true;
                this.selectedVotes = this.singleEvote;
            }
        }
        const sub = this.meetingService.getVotesData(id).subscribe((resp: any) => {
            this.evotes[id] = resp;
            this.singleEvote = resp;
            let votinResult = this.singleEvote?.VT_VoteResults;
            if (votinResult) {
                this.showVotes = true;
                this.selectedVotes = this.singleEvote;
            }

            (async () => {
                const selectedVotesCloned = JSON.parse(JSON.stringify(this.selectedVotes));
                const allValuesOfMeeting: { hash: string, value: string }[] = this.translationHelpers.collectUniqueStrings(selectedVotesCloned, { VT_Entity: 1 });
                this.translationStarted.emit();
                try {
                    const translationOutput: any = await this.meetingService.getTranslations(allValuesOfMeeting);
                    this.selectedVotes = this.translationHelpers.restoreOriginalStrings(selectedVotesCloned, translationOutput.lines);
                } catch (e) {
                }
                this.cd.detectChanges();
            })();

            sub.unsubscribe();
        });
    }

    modalClosed(status) {
        this.showVotes = false;
        this.showSponsorship = false;
    }

    checkReferenceExist(meeting) {
        let status = false;
        if (meeting.MT_jcmsMeetingId) {
            return true;
        }
        if (meeting.MT_number && this.currentBody == 'plenary') {
            return true;
        }
        if (meeting.MT_number && this.currentBody == 'ffd4pc') {
            return false;
        }
        if (meeting.MT_number && this.currentBody != 'plenary') {
            return true;
        }
        return false;
    }

    getOral(step) {
        const { PS_oralChanges, PS_documentAmended } = step;
        let text = '';
        if (step.PS_type && step.PS_type.label == 'Statement to orally change') {
            return ''
        }
        if (PS_oralChanges.indexOf('Oral revision') > -1) {
            text = 'as orally revised';
        }
        if (PS_oralChanges.indexOf('Oral correction') > -1) {
            if (text != '') {
                text += ', as orally corrected';
            } else {
                text = 'as orally corrected';
            }
        }
        if (PS_oralChanges.indexOf('Oral amendment') > -1) {
            if (text != '') {
                text += ', as orally amended';
            } else {
                text = 'as orally amended';
            }
        }
        if (PS_oralChanges.indexOf('As technically adjusted') > -1) {
            if (text != '') {
                text += ', as technically adjusted';
            } else {
                text = 'as technically adjusted';
            }
        }
        if (PS_documentAmended == "True") {
            if (text == "") {
                text = "as amended";
            } else {
                text += " as amended";
            }
        }
        return text;
    }

    getStepText(step, segment) {
        let documentSymbols = this.getSymbols(step.PS_selectDocumentFromWorkPackage);
        let text = '';
        if (!step.PS_type) {
            return text;
        }
        switch (step.PS_type.label) {
            case 'Document drawn attention to' :
                text = `Attention was drawn to document ${documentSymbols}`;
                break;
            case 'Statement on programme budget implications' :
                let text2 = step.PS_text1 != '' ? `(${step.PS_text1})` : step.PS_secondaryDocument ? `(${this.getSymbols(step.PS_secondaryDocument)})` : '';
                text = `Statement of Programme Budgetary Implications of ${documentSymbols} ${text2}`;
                break;
            case 'Withdrawal (Second Committee)' :
                text = `The proposal ${documentSymbols} was withdrawn`;
                break;
            case 'Agenda item status' :
                text = this.getAgendaWithStatus(step);
                break;
            case 'Document taken note of' :
                text = this.getPatargraph(step, segment);
                break;
            case 'Heading (iGov)':
                text = step.PS_text1;
                break;
            case 'Appointment':
                let _text = step.PS_text1 + ' ' + (step.PS_text2) || '' + ' ' + (step.PS_text3) || '';
                text = `Appointment: ${_text.trim()} ${this.getLisofSpeakerNamesWithFuncationTitleLater(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)}`;
                break;
            case 'Election: by secret ballot (simple)':
                let _text1 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' ' + step.PS_text3 || '';
                text = `Election: by secret ballot: ${_text1.trim()} ${this.getLisofSpeakerNamesWithFuncationTitleLater(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)}`;
                break;
            case 'Election: by acclamation':
                let _text2 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' ' + step.PS_text3 || '';
                text = `Election: by acclamation: ${_text2.trim()} ${this.getLisofSpeakerNamesWithFuncationTitleLater(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)}`;
                break;
            case 'Election: proceed to':
                let _text3 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' ' + step.PS_text3 || '';
                text = `Election: proceed to ${_text3.trim()}`;
                break;
            case 'Election: ballot results (conclusive)':
                let _text4 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' ' + step.PS_text3 || '';
                text = `Election ballot results (conclusive): ${_text4.trim()}`;
                break;
            case 'Election: ballot result (inconclusive)':
                let _text5 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' ' + step.PS_text3 || '';
                text = `Election ballot results (inconclusive): ${_text5.trim()}`;
                break;
            case 'Statement by the presiding officer':
                if (this.checkTag(step.PS_tags, 'Response')) {
                    text = step.PS_type.label + " (response)";
                } else {
                    text = step.PS_type.label;
                }
                break;
            case 'Statement by the Secretariat':
                if (this.checkTag(step.PS_tags, 'Response')) {
                    text = step.PS_type.label + " (response)";
                } else {
                    text = step.PS_type.label;
                }
                break;
            case 'Statement by the Secretary-General':
                if (this.checkTag(step.PS_tags, 'Response')) {
                    text = step.PS_type.label + " (response)";
                } else {
                    text = step.PS_type.label;
                }
                break;
            case 'Statements before adoption (Third Committee)':
                text = 'Statement(s) (before): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
                break;
            case 'Statements after adoption (Third Committee)':
                text = 'Statement(s) (after): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
                break;
            case 'Statements in explanation of vote before the vote':
                text = 'Explanation of vote (before): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
                break;
            case 'Statements in explanation of vote after the vote':
                text = 'Explanation of vote (after): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
                break;
            case 'Point of order':
                text = 'Point(s) of order: ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
                break;
            case 'Right of reply' :
                // console.log
                text = `Right of reply: ${this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true)}`;
                break;
            case 'Statements':
                let tagUsesd = false;
                if (this.checkTag(step.PS_tags, 'Introductory statement')) {
                    tagUsesd = true;
                    text = 'Introductory statement(s): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
                }
                if (this.checkTag(step.PS_tags, 'Statement and moderation')) {
                    tagUsesd = true;
                    text = 'Statement and moderation: ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
                }
                if (this.checkTag(step.PS_tags, 'Interactive discussion presenters responded')) {
                    tagUsesd = true;
                    text = 'Interactive discussion presenters responded';
                }
                if (this.checkTag(step.PS_tags, 'Interactive discussion')) {
                    tagUsesd = true;
                    text = 'Interactive discussion: ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
                }
                if (this.checkTag(step.PS_tags, 'Presentations')) {
                    tagUsesd = true;
                    text = 'Presentations: ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
                }
                if (this.checkTag(step.PS_tags, 'NGO(s)')) {
                    tagUsesd = true;
                    text = 'Statements (NGOs): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
                }
                if (this.checkTag(step.PS_tags, 'General discussion')) {
                    tagUsesd = true;
                    text = 'General discussion: ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
                }
                if (this.checkTag(step.PS_tags, 'Presentation')) {
                    tagUsesd = true;
                    text = 'Presentations(s): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
                }
                if (this.checkTag(step.PS_tags, 'Presentations')) {
                    tagUsesd = true;
                    text = 'Presentations(s): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
                }
                if (this.checkTag(step.PS_tags, 'Statements (observers)')) {
                    tagUsesd = true;
                    text = 'Statements (observers): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
                }
                if (!tagUsesd && !step.PS_linkListOfSpeakers.RF_id && this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers) != '') {
                    text = 'Statement(s): ' + this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
                }
                break;

        }
        return text;
    }

    checkTag(tagList, tagName) {
        return tagList.find(tag => tag.LKP_ValueShort == tagName);
    }

    getLisofSpeakerNames(speakers, PS_linkListOfSpeakers, onlyEntity = false, checkLevel = false) {
        let _spekers = [];
        for (let speaker of speakers) {
            let slot = true;
            if (PS_linkListOfSpeakers && ((PS_linkListOfSpeakers.startSlot == '') || parseInt(speaker.SP_slotNo) >= parseInt(PS_linkListOfSpeakers.startSlot) && parseInt(speaker.SP_slotNo) <= parseInt(PS_linkListOfSpeakers.endSlot))) {
                slot = false;
            }
            if (slot) {
                continue;
            }
            let speakerName = [];
            if (checkLevel && ['', 'Chair of Delegation'].indexOf(speaker.SP_LS_lvlRepr.SP_LS_lvlRepr) > -1) {
                onlyEntity = true;
            }
            if (!onlyEntity) {
                let title = speaker.SP_LS_funcTitle ? speaker.SP_LS_funcTitle : '';
                if (title)
                    speakerName.push(title)
                let name = `${speaker.SP_LS_title.SP_LS_title || ''} ${speaker.SP_LS_fname || ''} ${speaker.SP_LS_lname || ''}`;
                if (name.trim().length > 0 && name.trim() != 'null')
                    speakerName.push(name)
            }
            if (speaker.SP_entity.SP_entity)
                speakerName.push(speaker.SP_entity.SP_entity)
            if (Array.isArray(speaker.SP_LS_onbehalf) && speaker.SP_LS_onbehalf.length > 0) {
                speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf.join(' '))
            } else if (speaker.SP_LS_onbehalf.length > 0) {
                speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf)
            }
            _spekers.push(speakerName.join(', '));
        }
        return _spekers.join('; ');
    }

    getLisofSpeakerNamesWithFuncationTitleLater(speakers, PS_linkListOfSpeakers, onlyEntity = false, checkLevel = false) {
        let _spekers = [];
        for (let speaker of speakers) {
            let slot = true;
            if (PS_linkListOfSpeakers && ((PS_linkListOfSpeakers.startSlot == '') || parseInt(speaker.SP_slotNo) >= parseInt(PS_linkListOfSpeakers.startSlot) && parseInt(speaker.SP_slotNo) <= parseInt(PS_linkListOfSpeakers.endSlot))) {
                slot = false;
            }
            if (slot) {
                continue;
            }
            let speakerName = [];
            if (checkLevel && ['', 'Chair of Delegation'].indexOf(speaker.SP_LS_lvlRepr.SP_LS_lvlRepr) > -1) {
                onlyEntity = true;
            }
            if (!onlyEntity) {

                let name = `${speaker.SP_LS_title.SP_LS_title || ''} ${speaker.SP_LS_fname || ''} ${speaker.SP_LS_lname || ''}`;
                if (name.trim().length > 0 && name.trim() != 'null')
                    speakerName.push(name)

                let title = speaker.SP_LS_funcTitle ? speaker.SP_LS_funcTitle : '';
                if (title)
                    speakerName.push(title)
            }
            if (speaker.SP_entity.SP_entity)
                speakerName.push(speaker.SP_entity.SP_entity)
            if (Array.isArray(speaker.SP_LS_onbehalf) && speaker.SP_LS_onbehalf.length > 0) {
                speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf.join(' '))
            } else if (speaker.SP_LS_onbehalf.length > 0) {
                speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf)
            }
            _spekers.push(speakerName.join(', '));
        }
        return _spekers.join('; ');
    }

    getAgendas(agendas) {
        let links = [];
        if (agendas) {
            for (let agenda of agendas) {
                links.push(`<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + agenda.item}">${'Item ' + agenda.item}</a>`)
            }
            return links.join(',');
        }
        return '';
    }

    getAgendaWithStatus(step) {
        let items = this.getAgendas(step.PS_agenda);
        let status = '';
        switch (step.PS_agendaStatus) {
            case 'begin':
                status = 'began'
                break;
            case 'continue':
                status = 'continued'
                break;
            case 'resume':
                status = 'resumed'
                break;
            case 'keep open':
                status = 'keep open'
                break;
            case 'conclude':
                status = 'concluded'
                break;

        }
        if (status == 'keep open') {
            return `Concluded this stage of ${items}`
        }
        return `The consideration of ${items} ${status}`
    }
}
